import React from 'react'
import './Carosel.css'
import Slider from 'react-slick'
import {
  IMAGE_BASE_PATH_DBRALC,
  IMAGE_BASE_PATH_COMMON,
} from '../../Config/Config'

const Image_Carosel = (props) => {
  const { image_data, imageStyle } = props
  const defaultStyles = {
    width: '100%',
    height: '390px',
    objectFit: 'cover',
    borderRadius: '8px',
  }

  return (
    <div className="Image_carosel">
      <Slider
        ref={(slider) => slider}
        arrows={false}
        autoplay={true}
        dots={true}
      >
        {image_data &&
          image_data.map((items, index) => {
            return (
              <div key={index}>
                <img
                  src={
                    items === ''
                      ? IMAGE_BASE_PATH_COMMON +
                        'Placeholders/Placeholder_Image.jpg'
                      : // : IMAGE_BASE_PATH + ASSET_FOLDER + items
                        IMAGE_BASE_PATH_DBRALC + items.image_url
                  }
                  alt="events data"
                  loading="lazy"
                  placeholder="blur"
                  style={
                    imageStyle
                      ? { ...defaultStyles, ...imageStyle }
                      : defaultStyles
                  } // Merge styles
                  onError={(e) =>
                    (e.target.src =
                      IMAGE_BASE_PATH_COMMON +
                      'Placeholders/Placeholder_Image.jpg')
                  }
                />
              </div>
            )
          })}
      </Slider>
    </div>
  )
}

export default Image_Carosel
